import React, { useEffect, useState } from 'react';
export function TopBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full flex flex-col shadow-md" data-id="element-303">
      <div className="bg-black text-white py-2 px-4 text-center text-sm md:text-base font-bold flex justify-center items-center gap-2" data-id="element-304">
        <span data-id="element-305">⏳ OFERTA EXPIRA EN:</span>
        <span className="text-yellow-400 font-mono text-lg" data-id="element-306">
          {formattedTime}
        </span>
        <span data-id="element-307">| 🔥 CUPOS LIMITADOS</span>
      </div>
      <div className="bg-red-600 text-white py-1.5 px-4 text-center text-xs md:text-sm font-semibold" data-id="element-308">
        ⚡ Los 3 Bonos son GRATIS solo por hoy — Mañana se venden por separado a
        97€
      </div>
    </div>;
}